/* =====================================================================
   TERSELLE — interacciones de las secciones propias (ts-)
   Se carga UNA sola vez desde layout/theme.liquid. Cada componente se
   marca al inicializarse para que el editor de Shopify pueda recargar
   secciones sin duplicar escuchas.
   ===================================================================== */
(function () {
  'use strict';
  if (window.__tsScripts) return;
  window.__tsScripts = true;

  var $ = function (sel, raiz) { return (raiz || document).querySelector(sel); };
  var $$ = function (sel, raiz) { return Array.prototype.slice.call((raiz || document).querySelectorAll(sel)); };
  var movimientoReducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function preparar(el, clave) {
    var k = 'ts' + (clave || 'Listo');
    if (el.dataset[k]) return false;
    el.dataset[k] = '1';
    return true;
  }

  /* --- Dinero con el formato de la tienda ----------------------------- */
  function formatoDinero(centimos) {
    var formato = window.tsFormatoDinero || '{{amount_with_comma_separator}} €';
    var valor = Number(centimos) / 100;
    function separar(num, decimales, miles, decimal) {
      var partes = num.toFixed(decimales).split('.');
      partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, miles);
      return partes.join(decimales ? decimal : '');
    }
    return formato.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, tipo) {
      switch (tipo) {
        case 'amount': return separar(valor, 2, ',', '.');
        case 'amount_no_decimals': return separar(valor, 0, ',', '.');
        case 'amount_with_comma_separator': return separar(valor, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return separar(valor, 0, '.', ',');
        case 'amount_with_space_separator': return separar(valor, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return separar(valor, 0, ' ', ',');
        case 'amount_with_apostrophe_separator': return separar(valor, 2, "'", '.');
        default: return separar(valor, 2, '.', ',');
      }
    }).replace(/<[^>]*>/g, '');
  }
  window.tsFormatoDineroFn = formatoDinero;

  /* --- Un único observador para todo lo que se anima al aparecer ------ */
  var observador = null;
  function alAparecer(el, fn, margen) {
    if (!('IntersectionObserver' in window)) { fn(el); return; }
    if (!observador) {
      observador = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (en) {
          if (!en.isIntersecting) return;
          var cb = en.target.__tsAlAparecer;
          observador.unobserve(en.target);
          if (cb) cb.forEach(function (f) { f(en.target); });
        });
      }, { rootMargin: margen || '0px 0px -40px 0px', threshold: 0 });
    }
    (el.__tsAlAparecer = el.__tsAlAparecer || []).push(fn);
    observador.observe(el);
  }

  function initReveal(raiz) {
    $$('.ts-reveal', raiz).forEach(function (el) {
      if (!preparar(el, 'Reveal')) return;
      if (movimientoReducido || document.documentElement.classList.contains('shopify-design-mode')) {
        el.classList.add('ts-visible');
        return;
      }
      alAparecer(el, function (e) { e.classList.add('ts-visible'); });
    });
  }

  /* --- Barra de anuncios -------------------------------------------- */
  function initAnuncios(raiz) {
    $$('[data-ts-anuncio]', raiz).forEach(function (barra) {
      if (!preparar(barra)) return;
      var msgs = $$('.ts-anuncio__msg', barra);
      if (msgs.length < 2) return;
      var actual = 0;
      var segundos = parseFloat(barra.dataset.intervalo || '5');
      var temporizador = null;
      function ir(i) {
        msgs[actual].classList.remove('is-activo');
        actual = (i + msgs.length) % msgs.length;
        msgs[actual].classList.add('is-activo');
      }
      function arrancar() {
        parar();
        if (barra.dataset.auto === 'true' && !movimientoReducido) temporizador = setInterval(function () { ir(actual + 1); }, segundos * 1000);
      }
      function parar() { if (temporizador) clearInterval(temporizador); temporizador = null; }
      var prev = $('[data-ts-prev]', barra);
      var next = $('[data-ts-next]', barra);
      if (prev) prev.addEventListener('click', function () { ir(actual - 1); arrancar(); });
      if (next) next.addEventListener('click', function () { ir(actual + 1); arrancar(); });
      barra.addEventListener('mouseenter', parar);
      barra.addEventListener('mouseleave', arrancar);
      barra.__tsIr = function (i) { ir(i); parar(); };
      arrancar();
    });
  }

  /* --- Galería del producto ----------------------------------------- */
  function initGalerias(raiz) {
    $$('[data-ts-galeria]', raiz).forEach(function (gal) {
      if (!preparar(gal)) return;
      var pista = $('[data-ts-pista]', gal);
      if (!pista) return;
      var slides = $$('.ts-galeria__slide', pista);
      var minis = $$('.ts-galeria__mini', gal);
      var contador = $('[data-ts-contador]', gal);
      var actual = 0;

      function marcar(i) {
        actual = i;
        minis.forEach(function (m, j) { m.classList.toggle('is-activa', j === i); });
        if (minis[i] && minis[i].scrollIntoView && gal.dataset.listo) {
          var cont = minis[i].parentElement;
          var izq = minis[i].offsetLeft - cont.clientWidth / 2 + minis[i].clientWidth / 2;
          cont.scrollTo({ left: izq, behavior: 'smooth' });
        }
        if (contador) contador.textContent = (i + 1) + ' / ' + slides.length;
        slides.forEach(function (s, j) {
          if (j === i) return;
          $$('video', s).forEach(function (v) { if (!v.paused) v.pause(); });
        });
      }
      function ir(i) {
        if (!slides.length) return;
        i = Math.max(0, Math.min(slides.length - 1, i));
        pista.scrollTo({ left: slides[i].offsetLeft, behavior: movimientoReducido ? 'auto' : 'smooth' });
        marcar(i);
      }
      minis.forEach(function (m, i) { m.addEventListener('click', function () { ir(i); }); });
      var prev = $('[data-ts-prev]', gal);
      var next = $('[data-ts-next]', gal);
      if (prev) prev.addEventListener('click', function () { ir(actual === 0 ? slides.length - 1 : actual - 1); });
      if (next) next.addEventListener('click', function () { ir(actual === slides.length - 1 ? 0 : actual + 1); });
      var espera = null;
      pista.addEventListener('scroll', function () {
        clearTimeout(espera);
        espera = setTimeout(function () {
          var i = Math.round(pista.scrollLeft / Math.max(1, pista.clientWidth));
          if (i !== actual) marcar(i);
        }, 60);
      }, { passive: true });
      gal.__tsIrAMedia = function (mediaId) {
        var idx = slides.findIndex(function (s) { return s.dataset.mediaId === String(mediaId); });
        if (idx > -1) ir(idx);
      };
      marcar(0);
      gal.dataset.listo = '1';
    });
  }

  /* --- Añadir al carrito y abrir el carrito lateral de Dawn ------------ */
  function anadirAlCarrito(items, opciones) {
    opciones = opciones || {};
    var cajon = document.querySelector('cart-drawer');
    var cuerpo = { items: items };
    if (cajon) {
      cuerpo.sections = ['cart-drawer', 'cart-icon-bubble'];
      cuerpo.sections_url = window.location.pathname;
    }
    var raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(raiz + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(cuerpo)
    }).then(function (r) {
      return r.json().then(function (json) {
        if (!r.ok) {
          var err = new Error(json.description || json.message || 'Error');
          err.descripcion = json.description || json.message;
          throw err;
        }
        return json;
      });
    }).then(function (json) {
      if (opciones.accion === 'checkout') { window.location.href = raiz + 'checkout'; return json; }
      if (opciones.accion === 'carrito' || !cajon || typeof cajon.renderContents !== 'function') {
        window.location.href = raiz + 'cart';
        return json;
      }
      cajon.classList.remove('is-empty');
      cajon.renderContents(json);
      document.dispatchEvent(new CustomEvent('ts:carrito-actualizado', { detail: json }));
      return json;
    });
  }
  window.tsAnadirAlCarrito = anadirAlCarrito;

  function estadoCargando(boton, cargando) {
    if (!boton) return;
    boton.classList.toggle('is-cargando', cargando);
    boton.setAttribute('aria-busy', cargando ? 'true' : 'false');
    if (cargando) boton.dataset.tsDeshabilitado = boton.disabled ? '1' : '';
    boton.disabled = cargando ? true : boton.dataset.tsDeshabilitado === '1';
  }

  /* --- Ficha de producto: variantes, precio, botón y barra fija ------- */
  function initProductos(raiz) {
    $$('[data-ts-producto]', raiz).forEach(function (prod) {
      if (!preparar(prod)) return;
      var datos = $('[data-ts-variantes]', prod);
      var formulario = $('form[data-ts-form]', prod);
      var inputId = formulario ? $('input[name="id"]', formulario) : null;
      var boton = $('[data-ts-boton]', prod);
      var botonTexto = boton ? $('[data-ts-boton-texto]', boton) : null;
      var errorEl = $('[data-ts-error]', prod);
      var galeria = $('[data-ts-galeria]', prod);
      var seccion = prod.closest('.ts-producto-sec') || prod.parentElement;
      var barra = $('[data-ts-barra-fija]', seccion);
      var variantes = [];
      try { variantes = datos ? JSON.parse(datos.textContent) : []; } catch (e) { variantes = []; }

      function porcentaje(v) {
        if (!v || !v.compare_at_price || v.compare_at_price <= v.price) return 0;
        return Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price);
      }
      function rellenar(plantilla, v) {
        return String(plantilla || '')
          .replace(/\[descuento\]/gi, porcentaje(v) + '%')
          .replace(/\[precio\]/gi, formatoDinero(v.price))
          .replace(/\[ahorro\]/gi, formatoDinero(Math.max(0, (v.compare_at_price || 0) - v.price)));
      }
      function varianteSeleccionada() {
        var grupos = $$('[data-ts-opcion-grupo]', prod);
        if (!grupos.length) return null;
        var valores = grupos.map(function (g) {
          var marcado = $('input:checked', g);
          return marcado ? marcado.value : null;
        });
        return variantes.find(function (v) {
          return v.options.every(function (o, i) { return valores[i] === null || valores[i] === undefined || o === valores[i]; });
        }) || null;
      }
      function pintar(v) {
        if (!v) {
          if (boton) { boton.disabled = true; if (botonTexto) botonTexto.textContent = boton.dataset.noDisponible || 'No disponible'; }
          return;
        }
        if (inputId) inputId.value = v.id;
        var pct = porcentaje(v);
        $$('[data-ts-precio]', seccion).forEach(function (el) { el.textContent = formatoDinero(v.price); });
        $$('[data-ts-precio-antes]', seccion).forEach(function (el) {
          el.textContent = pct > 0 ? formatoDinero(v.compare_at_price) : '';
          el.hidden = pct <= 0;
        });
        $$('[data-ts-ahorro]', prod).forEach(function (el) {
          el.hidden = pct <= 0;
          if (pct > 0) el.textContent = rellenar(el.dataset.plantilla || 'Ahorra [descuento]', v);
        });
        $$('[data-ts-cuota]', prod).forEach(function (el) {
          var n = parseInt(el.dataset.plazos || '3', 10);
          el.textContent = formatoDinero(Math.ceil(v.price / n));
        });
        if (boton) {
          var texto;
          if (!v.available) {
            texto = boton.dataset.agotado || 'Agotado';
            boton.disabled = true;
          } else {
            texto = pct > 0 ? rellenar(boton.dataset.texto, v) : rellenar(boton.dataset.textoSin || boton.dataset.texto, v);
            boton.disabled = false;
          }
          if (botonTexto) botonTexto.textContent = texto;
        }
        if (barra) {
          var bb = $('[data-ts-barra-boton]', barra);
          if (bb) bb.disabled = !v.available;
        }
        if (galeria && galeria.__tsIrAMedia && v.featured_media) galeria.__tsIrAMedia(v.featured_media.id);
        if (prod.dataset.actualizarUrl === 'true' && window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
        if (errorEl) errorEl.textContent = '';
      }

      $$('[data-ts-opcion-grupo] input', prod).forEach(function (inp) {
        inp.addEventListener('change', function () { pintar(varianteSeleccionada()); });
      });

      /* Cantidad */
      $$('[data-ts-cantidad]', prod).forEach(function (c) {
        var inp = $('input', c);
        $$('button', c).forEach(function (b) {
          b.addEventListener('click', function () {
            var n = parseInt(inp.value || '1', 10) + (b.dataset.paso === '-1' ? -1 : 1);
            inp.value = Math.max(1, n);
          });
        });
      });

      if (formulario) {
        formulario.addEventListener('submit', function (ev) {
          ev.preventDefault();
          if (!inputId || !inputId.value || (boton && boton.disabled && !boton.classList.contains('is-cargando'))) return;
          var cant = $('input[name="quantity"]', formulario);
          var items = [{ id: Number(inputId.value), quantity: Math.max(1, parseInt(cant ? cant.value : '1', 10) || 1) }];
          estadoCargando(boton, true);
          anadirAlCarrito(items, { accion: prod.dataset.accion })
            .catch(function (err) {
              if (errorEl) errorEl.textContent = err.descripcion || 'No se ha podido añadir. Inténtalo de nuevo.';
            })
            .finally(function () { estadoCargando(boton, false); });
        });
      }

      /* Barra de compra fija */
      if (barra && boton && 'IntersectionObserver' in window) {
        var ioBarra = new IntersectionObserver(function (en) {
          var e = en[0];
          var pasado = !e.isIntersecting && e.boundingClientRect.top < 0;
          barra.classList.toggle('is-visible', pasado);
        }, { threshold: 0 });
        ioBarra.observe(boton);
        var bb = $('[data-ts-barra-boton]', barra);
        if (bb) bb.addEventListener('click', function () {
          if (barra.dataset.accion === 'subir') {
            prod.scrollIntoView({ behavior: movimientoReducido ? 'auto' : 'smooth', block: 'start' });
          } else if (formulario) {
            if (formulario.requestSubmit) formulario.requestSubmit(); else boton.click();
          }
        });
      }

      if (variantes.length) {
        var inicial = varianteSeleccionada() || variantes.find(function (v) { return String(v.id) === String(inputId && inputId.value); });
        if (inicial) pintar(inicial);
      }
    });
  }

  /* --- Botones "Añadir" de las tarjetas de packs --------------------- */
  function initPacks(raiz) {
    $$('[data-ts-pack-add]', raiz).forEach(function (b) {
      if (!preparar(b)) return;
      b.addEventListener('click', function (ev) {
        ev.preventDefault();
        var id = Number(b.dataset.variante);
        if (!id) return;
        estadoCargando(b, true);
        anadirAlCarrito([{ id: id, quantity: 1 }], { accion: b.dataset.accion })
          .catch(function () { window.location.href = b.getAttribute('href') || '/cart'; })
          .finally(function () { estadoCargando(b, false); });
      });
    });
  }

  /* --- Acordeones (preguntas frecuentes) ----------------------------- */
  function initAcordeones(raiz) {
    $$('[data-ts-acordeon]', raiz).forEach(function (ac) {
      if (!preparar(ac)) return;
      var uno = ac.dataset.uno === 'true';
      $$('.ts-faq__item', ac).forEach(function (item) {
        var btn = $('.ts-faq__pregunta', item);
        if (!btn) return;
        btn.addEventListener('click', function () {
          var abrir = !item.classList.contains('is-abierto');
          if (uno) $$('.ts-faq__item.is-abierto', ac).forEach(function (o) {
            if (o !== item) { o.classList.remove('is-abierto'); var b = $('.ts-faq__pregunta', o); if (b) b.setAttribute('aria-expanded', 'false'); }
          });
          item.classList.toggle('is-abierto', abrir);
          btn.setAttribute('aria-expanded', abrir ? 'true' : 'false');
        });
      });
    });
  }

  /* --- Pestañas de testimonios -------------------------------------- */
  function initPestanas(raiz) {
    $$('[data-ts-pestanas]', raiz).forEach(function (cont) {
      if (!preparar(cont)) return;
      var tabs = $$('[data-ts-pestana]', cont);
      var paneles = $$('[data-ts-panel]', cont);
      var actual = 0;
      var temporizador = null;
      function ir(i) {
        actual = (i + tabs.length) % tabs.length;
        tabs.forEach(function (t, j) { t.classList.toggle('is-activa', j === actual); t.setAttribute('aria-selected', j === actual ? 'true' : 'false'); });
        paneles.forEach(function (p, j) { p.classList.toggle('is-activo', j === actual); p.setAttribute('aria-hidden', j === actual ? 'false' : 'true'); });
      }
      function auto() {
        clearInterval(temporizador);
        var s = parseFloat(cont.dataset.auto || '0');
        if (s > 0 && !movimientoReducido) temporizador = setInterval(function () { ir(actual + 1); }, s * 1000);
      }
      tabs.forEach(function (t, i) { t.addEventListener('click', function () { ir(i); auto(); }); });
      cont.addEventListener('mouseenter', function () { clearInterval(temporizador); });
      cont.addEventListener('mouseleave', auto);
      cont.__tsIr = function (i) { ir(i); clearInterval(temporizador); };
      ir(0);
      auto();
    });
  }

  /* --- Vídeos (carrusel y reseñas) ----------------------------------- */
  function pausarOtros(excepto) {
    $$('.ts-video video').forEach(function (v) {
      if (v !== excepto && !v.paused && !v.closest('[data-ts-auto="siempre"]')) {
        v.pause();
        var c = v.closest('.ts-video');
        if (c) c.classList.remove('is-reproduciendo');
      }
    });
  }
  function initVideos(raiz) {
    $$('.ts-video', raiz).forEach(function (tarjeta) {
      if (!preparar(tarjeta)) return;
      var video = $('video', tarjeta);
      var play = $('.ts-video__play', tarjeta);
      var modo = tarjeta.dataset.tsAuto || 'no';
      if (video) {
        video.removeAttribute('controls');
        video.playsInline = true;
        if (modo === 'siempre') {
          video.muted = true;
          video.loop = true;
          alAparecer(tarjeta, function () { var p = video.play(); if (p && p.catch) p.catch(function () {}); }, '0px');
        } else if (modo === 'hover' && window.matchMedia('(hover: hover)').matches) {
          tarjeta.addEventListener('mouseenter', function () {
            if (tarjeta.classList.contains('is-reproduciendo')) return;
            video.muted = true;
            var p = video.play(); if (p && p.catch) p.catch(function () {});
          });
          tarjeta.addEventListener('mouseleave', function () {
            if (tarjeta.classList.contains('is-reproduciendo')) return;
            video.pause();
          });
        }
      }
      if (play) play.addEventListener('click', function () {
        if (video) {
          pausarOtros(video);
          video.muted = false;
          video.controls = true;
          video.currentTime = modo === 'no' ? video.currentTime : 0;
          var p = video.play(); if (p && p.catch) p.catch(function () {});
          tarjeta.classList.add('is-reproduciendo');
        } else {
          var iframe = $('iframe[data-src]', tarjeta);
          if (iframe) {
            iframe.src = iframe.dataset.src;
            iframe.hidden = false;
            tarjeta.classList.add('is-reproduciendo');
          }
        }
      });
    });
    $$('[data-ts-videos]', raiz).forEach(function (car) {
      if (!preparar(car, 'Car')) return;
      var pista = $('.ts-videos__pista', car);
      var prev = $('[data-ts-prev]', car);
      var next = $('[data-ts-next]', car);
      function paso() { var t = $('.ts-video', pista); return t ? t.getBoundingClientRect().width + 24 : 300; }
      function revisar() {
        var hay = pista.scrollWidth > pista.clientWidth + 4;
        car.classList.toggle('ts-videos--con-flechas', hay);
      }
      if (prev) prev.addEventListener('click', function () { pista.scrollBy({ left: -paso(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { pista.scrollBy({ left: paso(), behavior: 'smooth' }); });
      revisar();
      window.addEventListener('resize', revisar);
    });
  }

  /* --- Ventana para ver fotos y vídeos de reseñas --------------------- */
  var modal = null;
  function abrirModal(contenido) {
    if (!modal) {
      modal = document.createElement('div');
      modal.className = 'ts-modal';
      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');
      modal.innerHTML = '<div class="ts-modal__caja"></div><button type="button" class="ts-modal__cerrar" aria-label="Cerrar"><svg class="ts-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg></button>';
      document.body.appendChild(modal);
      modal.addEventListener('click', function (e) { if (e.target === modal || e.target.closest('.ts-modal__cerrar')) cerrarModal(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') cerrarModal(); });
    }
    $('.ts-modal__caja', modal).innerHTML = contenido;
    modal.classList.add('is-abierto');
    var v = $('video', modal);
    if (v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    var c = $('.ts-modal__cerrar', modal);
    if (c) c.focus();
  }
  function cerrarModal() {
    if (!modal) return;
    modal.classList.remove('is-abierto');
    var v = $('video', modal);
    if (v) v.pause();
    setTimeout(function () { if (!modal.classList.contains('is-abierto')) $('.ts-modal__caja', modal).innerHTML = ''; }, 300);
  }
  function initMedios(raiz) {
    $$('[data-ts-abrir-media]', raiz).forEach(function (b) {
      if (!preparar(b)) return;
      b.addEventListener('click', function () {
        var plantilla = $('template', b);
        if (plantilla) abrirModal(plantilla.innerHTML);
      });
    });
  }

  /* --- Comparador antes/después -------------------------------------- */
  function initComparadores(raiz) {
    $$('[data-ts-comparador]', raiz).forEach(function (comp) {
      if (!preparar(comp)) return;
      var asa = $('.ts-comparador__asa', comp);
      var arrastrando = false;
      function poner(pct) {
        pct = Math.max(0, Math.min(100, pct));
        comp.style.setProperty('--pos', pct + '%');
        if (asa) asa.setAttribute('aria-valuenow', Math.round(pct));
      }
      function desdeEvento(e) {
        var r = comp.getBoundingClientRect();
        var x = (e.touches ? e.touches[0].clientX : e.clientX) - r.left;
        poner(x / r.width * 100);
      }
      comp.addEventListener('pointerdown', function (e) { arrastrando = true; desdeEvento(e); if (comp.setPointerCapture) comp.setPointerCapture(e.pointerId); });
      comp.addEventListener('pointermove', function (e) { if (arrastrando) desdeEvento(e); });
      comp.addEventListener('pointerup', function () { arrastrando = false; });
      comp.addEventListener('pointercancel', function () { arrastrando = false; });
      if (asa) asa.addEventListener('keydown', function (e) {
        var actual = parseFloat(asa.getAttribute('aria-valuenow') || '50');
        if (e.key === 'ArrowLeft') { poner(actual - 5); e.preventDefault(); }
        if (e.key === 'ArrowRight') { poner(actual + 5); e.preventDefault(); }
      });
      /* Pequeño vaivén al aparecer para que se entienda que se puede mover */
      if (!movimientoReducido && comp.dataset.pista === 'true') {
        alAparecer(comp, function () {
          var inicio = null;
          var base = parseFloat(getComputedStyle(comp).getPropertyValue('--pos')) || 50;
          function paso(t) {
            if (!inicio) inicio = t;
            var p = (t - inicio) / 1400;
            if (p >= 1 || arrastrando) { if (!arrastrando) poner(base); return; }
            poner(base + Math.sin(p * Math.PI * 2) * 12 * (1 - p));
            requestAnimationFrame(paso);
          }
          requestAnimationFrame(paso);
        });
      }
    });
  }

  /* --- Cifras que cuentan y anillos de porcentaje --------------------- */
  function contar(el, hasta, decimales, duracion) {
    var inicio = null;
    var fmt = new Intl.NumberFormat('es-ES', { minimumFractionDigits: decimales, maximumFractionDigits: decimales });
    function paso(t) {
      if (!inicio) inicio = t;
      var p = Math.min(1, (t - inicio) / duracion);
      var e = 1 - Math.pow(1 - p, 3);
      el.textContent = fmt.format(hasta * e);
      if (p < 1) requestAnimationFrame(paso);
    }
    if (movimientoReducido || document.hidden) { el.textContent = fmt.format(hasta); return; }
    requestAnimationFrame(paso);
    /* Por si el navegador frena las animaciones (pestaña en segundo plano) */
    setTimeout(function () { el.textContent = fmt.format(hasta); }, duracion + 400);
  }
  function initCifras(raiz) {
    $$('[data-ts-contar]', raiz).forEach(function (el) {
      if (!preparar(el)) return;
      var hasta = parseFloat(el.dataset.hasta || '0');
      var dec = parseInt(el.dataset.decimales || '0', 10);
      if (document.documentElement.classList.contains('shopify-design-mode')) return;
      alAparecer(el, function () { contar(el, hasta, dec, 1800); });
    });
    $$('[data-ts-anillo]', raiz).forEach(function (an) {
      if (!preparar(an)) return;
      var v = Math.max(0, Math.min(100, parseFloat(an.dataset.valor || '0')));
      var arco = $('.ts-anillo__valor', an);
      var circ = 251.33;
      alAparecer(an, function () {
        if (arco) arco.style.strokeDashoffset = String(circ * (1 - v / 100));
      });
    });
  }

  /* --- Reseñas: "Mostrar más" ---------------------------------------- */
  function initResenas(raiz) {
    $$('[data-ts-resenas]', raiz).forEach(function (sec) {
      if (!preparar(sec)) return;
      var btn = $('[data-ts-mas]', sec);
      if (!btn) return;
      var lote = parseInt(btn.dataset.lote || '6', 10);
      btn.addEventListener('click', function () {
        var ocultas = $$('.ts-resena[hidden]', sec);
        ocultas.slice(0, lote).forEach(function (r) { r.hidden = false; });
        if (ocultas.length <= lote) btn.parentElement.hidden = true;
      });
    });
  }

  /* --- Cuenta atrás -------------------------------------------------- */
  function initCuentas(raiz) {
    $$('[data-ts-cuenta]', raiz).forEach(function (c) {
      if (!preparar(c)) return;
      var fin;
      if (c.dataset.fin) {
        fin = new Date(c.dataset.fin).getTime();
      } else {
        var minutos = parseFloat(c.dataset.minutos || '15');
        var clave = 'ts-cuenta-' + (c.dataset.clave || 'general');
        try {
          var guardado = parseInt(localStorage.getItem(clave) || '0', 10);
          if (!guardado || guardado < Date.now()) {
            guardado = Date.now() + minutos * 60000;
            localStorage.setItem(clave, String(guardado));
          }
          fin = guardado;
        } catch (e) { fin = Date.now() + minutos * 60000; }
      }
      var cajas = { d: $('[data-d]', c), h: $('[data-h]', c), m: $('[data-m]', c), s: $('[data-s]', c) };
      function dos(n) { return (n < 10 ? '0' : '') + n; }
      function tic() {
        var resto = Math.max(0, fin - Date.now());
        var s = Math.floor(resto / 1000);
        if (cajas.d) cajas.d.textContent = dos(Math.floor(s / 86400));
        if (cajas.h) cajas.h.textContent = dos(Math.floor((s % 86400) / 3600));
        if (cajas.m) cajas.m.textContent = dos(Math.floor((s % 3600) / 60));
        if (cajas.s) cajas.s.textContent = dos(s % 60);
        if (resto <= 0 && !c.dataset.fin) {
          try { localStorage.removeItem('ts-cuenta-' + (c.dataset.clave || 'general')); } catch (e) {}
        }
      }
      tic();
      setInterval(tic, 1000);
    });
  }

  /* --- Ventana emergente de descuento -------------------------------- */
  function initPopups(raiz) {
    $$('[data-ts-popup]', raiz).forEach(function (pop) {
      if (!preparar(pop)) return;
      var clave = 'ts-popup-' + (pop.dataset.clave || 'visto');
      function abrir() { pop.classList.add('is-abierto'); pop.setAttribute('aria-hidden', 'false'); }
      function cerrar() {
        pop.classList.remove('is-abierto');
        pop.setAttribute('aria-hidden', 'true');
        try { localStorage.setItem(clave, String(Date.now())); } catch (e) {}
      }
      pop.__tsAbrir = abrir;
      pop.__tsCerrar = function () { pop.classList.remove('is-abierto'); };
      pop.addEventListener('click', function (e) {
        if (e.target === pop || e.target.closest('[data-ts-popup-cerrar]')) cerrar();
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && pop.classList.contains('is-abierto')) cerrar(); });
      $$('[data-ts-popup-opcion]', pop).forEach(function (b) {
        b.addEventListener('click', function () { pop.classList.add('is-revelado'); });
      });
      var copiar = $('[data-ts-copiar]', pop);
      if (copiar) copiar.addEventListener('click', function () {
        var codigo = pop.dataset.codigo || '';
        if (navigator.clipboard && codigo) navigator.clipboard.writeText(codigo).then(function () {
          copiar.textContent = copiar.dataset.copiado || '¡Copiado!';
        }).catch(function () {});
      });
      if (document.documentElement.classList.contains('shopify-design-mode')) return;
      var visto = null;
      try { visto = localStorage.getItem(clave); } catch (e) {}
      var dias = parseFloat(pop.dataset.dias || '7');
      if (visto && (Date.now() - parseInt(visto, 10)) < dias * 86400000) return;
      setTimeout(abrir, parseFloat(pop.dataset.retraso || '8') * 1000);
    });
  }

  /* --- Efecto de profundidad (paralaje suave) ------------------------ */
  var capasParalaje = [];
  var paralajeActivo = false;
  function moverParalaje() {
    paralajeActivo = false;
    var alto = window.innerHeight;
    capasParalaje.forEach(function (capa) {
      var r = capa.parentElement.getBoundingClientRect();
      if (r.bottom < 0 || r.top > alto) return;
      var progreso = (r.top + r.height / 2 - alto / 2) / alto;
      capa.style.transform = 'translate3d(0,' + (progreso * -40).toFixed(1) + 'px,0)';
    });
  }
  function initParalaje(raiz) {
    if (movimientoReducido) return;
    $$('[data-ts-paralaje]', raiz).forEach(function (capa) {
      if (!preparar(capa)) return;
      capasParalaje.push(capa);
    });
    if (capasParalaje.length && !window.__tsParalaje) {
      window.__tsParalaje = true;
      window.addEventListener('scroll', function () {
        if (!paralajeActivo) { paralajeActivo = true; requestAnimationFrame(moverParalaje); }
      }, { passive: true });
    }
    moverParalaje();
  }

  /* --- Arranque ------------------------------------------------------ */
  function arrancar(raiz) {
    raiz = raiz || document;
    initReveal(raiz);
    initAnuncios(raiz);
    initGalerias(raiz);
    initProductos(raiz);
    initPacks(raiz);
    initAcordeones(raiz);
    initPestanas(raiz);
    initVideos(raiz);
    initMedios(raiz);
    initComparadores(raiz);
    initCifras(raiz);
    initResenas(raiz);
    initCuentas(raiz);
    initPopups(raiz);
    initParalaje(raiz);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { arrancar(document); });
  } else {
    arrancar(document);
  }

  /* Editor de Shopify: recargar y señalar bloques */
  document.addEventListener('shopify:section:load', function (e) { arrancar(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var bloque = e.target;
    var tabs = bloque.closest('[data-ts-pestanas]');
    if (tabs && tabs.__tsIr && bloque.dataset.indice) tabs.__tsIr(parseInt(bloque.dataset.indice, 10));
    var anuncio = bloque.closest('[data-ts-anuncio]');
    if (anuncio && anuncio.__tsIr && bloque.dataset.indice) anuncio.__tsIr(parseInt(bloque.dataset.indice, 10));
  });
  document.addEventListener('shopify:section:select', function (e) {
    var pop = $('[data-ts-popup]', e.target);
    if (pop && pop.__tsAbrir) pop.__tsAbrir();
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    var pop = $('[data-ts-popup]', e.target);
    if (pop && pop.__tsCerrar) pop.__tsCerrar();
  });
})();
